import React, { useEffect, useState } from 'react';
import ModalComponent from '../../components/ModalComponent';
import Image from 'react-bootstrap/Image';
import '../../assets/style/Modal.css';
import { Button, Col, Label, Row } from 'reactstrap';
import ModalHeader from '../../components/ModalHeader';
import { CLICK_ACTIONS } from '../../utils/Constant';
import CenterSpinner from '../../components/CenterSpinner';
import EditIcon from '@mui/icons-material/Edit';
import {
  EmployeeDetailsType,
  LoggedUserType,
  ReportingUserTypeInterface,
  SelectOptionType,
} from '../../utils/Types';
import {
  checkNullValue,
  getBlankValueIfNUll,
  getDefaultImage,
  getPhotoSrc,
  getValueFromArrayObject,
} from '../../utils/Util';
import MTabs from '../../components/MTabs';
import { useAppDispatch, useAppSelector } from '../../store/redux-hooks';
import { employeeModalTabs } from '../admin-settings/AdminSettingsHelper';
import MSelect from '../../components/MSelect';
import {
  employeeDataSelector,
  fetchEmployeeDetails,
} from '../../features/employeeDataSlice';
import { findValueInMap, findValueInOptions } from '../../utils/TableHelper';
import { locationFilterSelector } from '../../features/locationFilterSlice';
import { updateStatus } from '../admin-settings/employee/EmployeeHelper';

import PersonalDetailsEdit from '../../components/PersonalDetailsEdit';
import { loginSelector } from '../../features/loginSlice';

interface IEmployeeInformationModalProps {
  isOpen: boolean;
  candidateId?: number;
  toggleModal: (action: string) => void;
  readOnly?: boolean;
  refreshData?: () => void;
}

const EmployeeInformationModal: React.FunctionComponent<
  IEmployeeInformationModalProps
> = ({
  isOpen,
  candidateId,
  toggleModal,
  readOnly = false,
  refreshData,
}: IEmployeeInformationModalProps) => {
  const [showLoader, setShowLoader] = useState<boolean>(false);
  const [activeTab, setActiveTab] = useState<number>();
  const dispatch = useAppDispatch();
  const employeeDetails: EmployeeDetailsType | null =
    useAppSelector(employeeDataSelector).employeeDetails;
  const employeeStatusOption: SelectOptionType[] =
    useAppSelector(employeeDataSelector).employeeStatus;
  const locationData = useAppSelector(locationFilterSelector);
  const [selectedStatus, setSelectedStatus] = useState<number | null>(
    employeeDetails?.reportingDetails?.employeeStatus ?? null
  );
  const getUserDetails = () => {
    if (candidateId) {
      dispatch(fetchEmployeeDetails({ id: candidateId }));
      setShowLoader(true);
    }
  };
  const [showPersonalEdit, setShowPersonalEdit] = useState(false);
  const loggedUser: LoggedUserType = useAppSelector(loginSelector).user;
  const canEditDetails = loggedUser?.roleId === 23;
  useEffect(() => {
    setShowLoader(false);
    if (employeeDetails?.reportingDetails?.employeeStatus) {
      setSelectedStatus(employeeDetails?.reportingDetails?.employeeStatus);
    }
  }, [employeeDetails]);
  useEffect(() => {
    getUserDetails();
  }, [candidateId]);

  return (
    <ModalComponent
      isOpen={isOpen}
      toggle={() => {
        toggleModal(CLICK_ACTIONS.NO_ACTION);
      }}
      className="modalWrapper"
      backdrop="static"
    >
      <div className="bg-white p-2 rounded border">
        <ModalHeader
          photoUrl={employeeDetails?.personalDetails?.photo}
          toggle={() => {
            toggleModal(CLICK_ACTIONS.NO_ACTION);
          }}
        />
        <Row className="justify-content-end mt-5 p-4">
          <Col xs={12}>
            <MTabs
              tabs={employeeModalTabs}
              setActiveTab={setActiveTab}
              customTabStyle={{
                parentTabProp: { backgroundColor: '#ffffff' },
                tabIndicatorProp: { height: '5px', backgroundColor: '#829ED1' },
                childActiveTabColor: '#829ED1',
              }}
            />
          </Col>
        </Row>

        {activeTab === 0 && (
          <div className="px-4 mb-5 pb-5">
            {canEditDetails && (
              <div className="d-flex justify-content-end mb-3">
                <Button
                  color="primary"
                  size="sm"
                  onClick={() => setShowPersonalEdit(true)}
                >
                  <EditIcon sx={{ fontSize: 16, marginRight: 1 }} />
                  Edit Personal Details
                </Button>
              </div>
            )}
            <Row>
              <Col xs={6} md={4}>
                <Label className="mb-0 model-label-name">Employee Id</Label>
                <br />
                <Label className="mb-0 model-label-value">
                  {checkNullValue(
                    employeeDetails?.personalDetails?.employeeUniqueId
                  )}
                </Label>
              </Col>
              <Col xs={6} md={4}>
                <Label className="mb-0 model-label-name">Employee Name</Label>
                <br />
                <Label className="mb-0 model-label-value">{` ${getBlankValueIfNUll(
                  employeeDetails?.personalDetails?.firstName ??
                    employeeDetails?.personalDetails?.fullname ??
                    employeeDetails?.personalDetails?.fullName
                )} ${getBlankValueIfNUll(employeeDetails?.personalDetails?.lastName)}`}</Label>
              </Col>
              <Col xs={12} md={4}>
                <Label className="mb-0 model-label-name">Gender</Label>
                <br />
                <Label className="mb-0 model-label-value">
                  {checkNullValue(employeeDetails?.personalDetails?.gender)}
                </Label>
              </Col>
            </Row>
            <Row className="mt-3">
              <Col xs={12} md={4}>
                <Label className="mb-0 model-label-name">Marital Status</Label>
                <br />
                <Label className="mb-0 model-label-value">
                  {checkNullValue(
                    employeeDetails?.personalDetails?.maritalStatus
                  )}
                </Label>
              </Col>
              <Col xs={12} md={4}>
                <Label className="mb-0 model-label-name">Contact Number</Label>

                <br />
                <Label className="mb-0 model-label-value">
                  {checkNullValue(
                    employeeDetails?.personalDetails?.mobileNumber
                  )}
                </Label>
              </Col>
              <Col xs={12} md={4}>
                <Label className="mb-0 model-label-name">Email Id</Label>
                <br />
                <Label className="mb-0 model-label-value">
                  {checkNullValue(employeeDetails?.personalDetails?.emailId)}
                </Label>
              </Col>
            </Row>
            <Row className="mt-3">
              <Col xs={12}>
                <Label className="mb-0 model-label-name">Address</Label>

                <br />
                <Label className="mb-0 model-label-value">
                  {checkNullValue(employeeDetails?.personalDetails?.address)}
                </Label>
              </Col>
            </Row>
            <Row className="mt-3">
              <Col xs={6} md={3}>
                <Label className="mb-0 model-label-name">City</Label>
                <br />
                <Label className="mb-0 model-label-value">
                  {findValueInMap(
                    locationData?.cityOptions,
                    employeeDetails?.personalDetails?.city,
                    employeeDetails?.personalDetails?.district
                  )}
                </Label>
              </Col>
              <Col xs={6} md={3}>
                <Label className="mb-0 model-label-name">State</Label>
                <br />
                <Label className="mb-0 model-label-value">
                  {findValueInMap(
                    locationData?.statesData,
                    employeeDetails?.personalDetails?.state,
                    employeeDetails?.personalDetails?.zone
                  )}
                </Label>
              </Col>
              <Col xs={6} md={3}>
                <Label className="mb-0 model-label-name">Pin Code</Label>
                <br />
                <Label className="mb-0 model-label-value">
                  {checkNullValue(employeeDetails?.personalDetails?.pincode)}
                </Label>
              </Col>
            </Row>
            {showPersonalEdit && (
              <PersonalDetailsEdit
                user={employeeDetails?.personalDetails}
                candidateId={candidateId}
                setEnableEditValue={setShowPersonalEdit}
                refreshData={refreshData}
                setShowLoader={setShowLoader}
              />
            )}
          </div>
        )}

        {activeTab === 1 && (
          <div className="px-4 mb-5 pb-5">
            <Row>
              <Col xs={6} md={4}>
                <Label className="mb-0 model-label-name">Role</Label>
                <br />
                <Label className="mb-0 model-label-value">
                  {getValueFromArrayObject(
                    employeeDetails?.roleDetails,
                    'roleName'
                  )}
                </Label>
              </Col>
              {/* <Col xs={6} md={4}>
                <Label className="mb-0 model-label-name">Designation</Label>
                <br />
                <Label className="mb-0 model-label-value">-</Label>
              </Col> */}
              <Col xs={6} md={4}>
                <Label className="mb-0 model-label-name">Employee Type</Label>
                <br />
                <Label className="mb-0 model-label-value">
                  {checkNullValue(
                    employeeDetails?.reportingDetails?.employeeTypeName
                  )}
                </Label>
              </Col>
              <Col xs={6} md={4}>
                <Label className="mb-0 model-label-name">Zone</Label>
                <br />
                <Label className="mb-0 model-label-value">
                  {findValueInOptions(
                    locationData.zoneOptions,
                    employeeDetails?.reportingDetails.zone
                  )}
                </Label>
              </Col>
            </Row>
            <Row className="mt-3">
              <Col xs={12} md={4}>
                <Label className="mb-0 model-label-name">State</Label>
                <br />
                <Label className="mb-0 model-label-value">
                  {findValueInMap(
                    locationData.statesData,
                    employeeDetails?.reportingDetails.state,
                    employeeDetails?.reportingDetails.zone
                  )}
                </Label>
              </Col>
              <Col xs={12} md={4}>
                <Label className="mb-0 model-label-name">District</Label>
                <br />
                <Label className="mb-0 model-label-value">
                  {findValueInMap(
                    locationData.districtData,
                    employeeDetails?.reportingDetails.district,
                    employeeDetails?.reportingDetails.state
                  )}
                </Label>
              </Col>
            </Row>
            <div className="mt-3">
              <p className="grid-details-wrapper">Grid Assigned Details</p>
              <Row>
                <Col xs={6} md={4}>
                  <Label className="mb-0 model-label-name">
                    Grid No. (Village ID)
                  </Label>
                  <br />
                  <Label className="mb-0 model-label-value">
                    {getValueFromArrayObject(
                      employeeDetails?.allocatedGrids,
                      'gridid'
                    )}
                  </Label>
                </Col>
                <Col xs={6} md={4}>
                  <Label className="mb-0 model-label-name">
                    Employee Status
                  </Label>
                  <br />
                  {readOnly ? (
                    <Label className="mb-0 model-label-value">
                      {checkNullValue(
                        employeeDetails?.reportingDetails?.employeeStatusName
                      )}
                    </Label>
                  ) : (
                    <MSelect
                      label="Employee Status"
                      hideLabel
                      options={employeeStatusOption}
                      value={selectedStatus}
                      onChange={(e) => {
                        setSelectedStatus(e.target.value);
                      }}
                    />
                  )}
                </Col>
              </Row>
            </div>
          </div>
        )}

        {activeTab === 2 && (
          <div className="px-4 mb-5 pb-5">
            {employeeDetails?.reportingManagerDetails?.candidateUniqueId && (
              <Row>
                <Col xs={6} md={2}>
                  <div className="d-flex">
                    <Image
                      className="rm-profile-image"
                      src={getPhotoSrc(
                        employeeDetails?.reportingManagerDetails.photo
                      )}
                      roundedCircle
                      width={80}
                      height={80}
                      onError={(e) => {
                        e.currentTarget.src = getDefaultImage();
                      }}
                    />
                  </div>
                </Col>
                <Col xs={6} md={3}>
                  <Label className="mb-0 model-label-name">
                    Reporting Manager Emp ID
                  </Label>
                  <br />
                  <Label className="mb-0 model-label-value">
                    {checkNullValue(
                      employeeDetails?.reportingManagerDetails.employeeUniqueId
                    )}
                  </Label>
                </Col>
                <Col xs={6} md={3}>
                  <Label className="mb-0 model-label-name">
                    Reporting Manager Emp Name
                  </Label>
                  <br />
                  <Label className="mb-0 model-label-value">
                    {' '}
                    {checkNullValue(
                      employeeDetails?.reportingManagerDetails.fullName
                    )}
                  </Label>
                </Col>
                <Col xs={12} md={3}>
                  <Label className="mb-0 model-label-name">Role</Label>
                  <br />
                  <Label className="mb-0 model-label-value">
                    {' '}
                    {checkNullValue(
                      employeeDetails?.reportingManagerDetails.roleName
                    )}
                  </Label>
                </Col>
              </Row>
            )}
            {!employeeDetails?.reportingManagerDetails?.candidateUniqueId && (
              <div className="d-flex justify-content-center">
                No Reporting Manager
              </div>
            )}
          </div>
        )}

        {activeTab === 3 && (
          <div className="px-4 mb-5 pb-5">
            {employeeDetails?.reporteesDetails.map(
              (reportee: ReportingUserTypeInterface, index: number) => (
                <>
                  <Row key={`row-${String(index)}`}>
                    <Col xs={6} md={2}>
                      <div className="d-flex">
                        <Image
                          className="rd-profile-image"
                          src={getPhotoSrc(reportee.photo)}
                          roundedCircle
                          width={80}
                          height={80}
                          onError={(e) => {
                            e.currentTarget.src = getDefaultImage();
                          }}
                        />
                      </div>
                    </Col>
                    <Col xs={6} md={3}>
                      <Label className="mb-0 model-label-name">
                        Reportee Emp ID
                      </Label>
                      <br />
                      <Label className="mb-0 model-label-value">
                        {reportee.employeeUniqueId}
                      </Label>
                    </Col>
                    <Col xs={6} md={3}>
                      <Label className="mb-0 model-label-name">
                        Reportee Emp Name
                      </Label>
                      <br />
                      <Label className="mb-0 model-label-value">
                        {reportee.fullName}
                      </Label>
                    </Col>
                    <Col xs={12} md={3}>
                      <Label className="mb-0 model-label-name">
                        Reportee Role
                      </Label>
                      <br />
                      <Label className="mb-0 model-label-value">
                        {reportee.roleName}
                      </Label>
                    </Col>
                  </Row>
                  <hr></hr>
                </>
              )
            )}
            {!employeeDetails?.reporteesDetails.length && (
              <div className="d-flex justify-content-center">No Reportees</div>
            )}
          </div>
        )}

        {!readOnly && (
          <div className="d-flex justify-content-center mt-5 pt-5">
            <Button
              variant="primary"
              className="m-1 cl-btn-primary"
              disabled={
                Number(activeTab) !== 1 ||
                selectedStatus ===
                  employeeDetails?.reportingDetails.employeeStatus
              }
              onClick={() => {
                updateStatus(
                  candidateId,
                  selectedStatus,
                  setShowLoader,
                  dispatch,
                  toggleModal
                );
              }}
            >
              Update
            </Button>
            <Button
              variant="outline-primary"
              className="m-1 cl-btn-outline-primary"
              onClick={() => {
                toggleModal(CLICK_ACTIONS.NO_ACTION);
              }}
            >
              Close
            </Button>
          </div>
        )}

        <CenterSpinner showLoader={showLoader} />
      </div>
    </ModalComponent>
  );
};

export default EmployeeInformationModal;
